import { useEffect, useState } from "react";
import NotificationList from "./NotificationList";
import {
  NavigationProps,
  NotificationSenderProps,
} from "../../../types/ComponentProps";
import NotificationStyles from "./Notification.module.css";
import useGetAllNotification from "../../../hooks/useGetAllNotification";
import { useNotification } from "../../../context/NotificationContext";

export const Notification = ({
  socket,
  notificationToggle,
  setNotificationToogle,
  setNotificationModal,
  setSelectedPostNotification,
  setSelectedNotificationId,
}: NavigationProps) => {
  const { getNotificationByIdData, refetch, isLoading } =
    useGetAllNotification();
  const { hasNewNotification, clearNewNotification } = useNotification();
  const [notification, setNotifications] = useState<NotificationSenderProps>(
    [],
  );

  const onClickHandler = () => {
    setNotificationToogle?.(!notificationToggle);
    clearNewNotification?.();
  };

  useEffect(() => {
    if (notification.length > 0) {
      refetch();
    }
  }, [notification, refetch]);

  useEffect(() => {
    if (socket) {
      const handleNewNotification = (data: NotificationSenderProps) => {
        setNotifications((previous: any) => [...previous, data]);
      };

      socket.on("getNotification", handleNewNotification);
      socket.on("getNotificationComment", handleNewNotification);
      socket.on("getNotificationMention", handleNewNotification);
      socket.on("getNotificationBadgeMention", handleNewNotification);
      socket.on("getNotificationCommentReaction", handleNewNotification);

      return () => {
        socket.off("getNotification", handleNewNotification);
        socket.off("getNotificationComment", handleNewNotification);
        socket.off("getNotificationMention", handleNewNotification);
        socket.off("getNotificationBadgeMention", handleNewNotification);
        socket.off("getNotificationCommentReaction", handleNewNotification);
      };
    }
  }, [socket]);

  return (
    <div className={NotificationStyles.notificationMainContainer}>
      {!isLoading &&
        getNotificationByIdData?.notifications.length > 0 && (
          <div className={NotificationStyles.notificationSpanCounter}>
            <span>
              {getNotificationByIdData?.notifications.length === 99
                ? `${getNotificationByIdData?.notifications.length}+`
                : getNotificationByIdData?.notifications.length}
            </span>
          </div>
        )}
      {hasNewNotification && (
        <div className={NotificationStyles.realtimeRedDot} />
      )}
      {notificationToggle && (
        <NotificationList
          setToggle={setNotificationToogle}
          setNotificationModal={setNotificationModal}
          setSelectedPostNotification={setSelectedPostNotification}
          setSelectedNotificationId={setSelectedNotificationId}
        />
      )}
      <button title="Notification" onClick={onClickHandler}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M7.79514 17.5C8.38275 18.0187 9.15462 18.3334 10 18.3334C10.8454 18.3334 11.6172 18.0187 12.2048 17.5M15 6.66669C15 5.3406 14.4732 4.06884 13.5355 3.13115C12.5978 2.19347 11.3261 1.66669 10 1.66669C8.67391 1.66669 7.40214 2.19347 6.46446 3.13115C5.52678 4.06884 5 5.3406 5 6.66669C5 9.24184 4.35039 11.005 3.62472 12.1712C3.0126 13.1549 2.70654 13.6468 2.71777 13.784C2.73019 13.9359 2.76238 13.9939 2.88481 14.0847C2.99538 14.1667 3.49382 14.1667 4.49071 14.1667H15.5093C16.5062 14.1667 17.0046 14.1667 17.1152 14.0847C17.2376 13.9939 17.2698 13.9359 17.2822 13.784C17.2934 13.6468 16.9874 13.1549 16.3753 12.1712C15.6496 11.005 15 9.24184 15 6.66669Z"
            stroke="white"
            stroke-width="1.66667"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>
  );
};
